export default "__VITE_ASSET__b7be3a49__"